const skills = [
  {
    img: "../images/html5.png",
    name: "HTML5",
    percentage: "85",
  },
  {
    img: "../images/css.png",
    name: "CSS3",
    percentage: "80",
  },
  {
    img: "../images/js.png",
    name: "JavaScript",
    percentage: "75",
  },
  {
    img: "../images/react.png",
    name: "ReactJS",
    percentage: "69",
  },
  {
    img: "../images/redux.png",
    name: "Redux",
    percentage: "57",
  },
  {
    img: "../images/next.png",
    name: "NextJS",
    percentage: "55",
  },
  {
    img: "../images/firebase.png",
    name: "Firebase",
    percentage: "70",
  },
  {
    img: "../images/tailwind.png",
    name: "TailwindCSS",
    percentage: "90",
  },
  {
    img: "../images/matrerialUI.png",
    name: "materialUI",
    percentage: "90",
  },
  {
    img: "../images/java.png",
    name: "JAVA",
    percentage: "60",
  },
];

export default skills;
